import React from 'react';
import { cardImages, cardPos } from 'constants/shared/enums';
import Card from '../presentational/Card';
import { accountRoles } from 'suits-me-npm/constants';

import PlaceholderCard from '_content/images/cards/placeholder-card.png';

const CarouselContainer = ({ cards, account, onAddCardHolderClick }) => {
    return (
        <div className="carousel-container">
            <div className="carousel-wrapper">
                {cards.map((card, index) => {
                    const position = cardPos[index];
                    return (
                        <div
                            key={index}
                            className={`carousel-item ${position}`}
                        >
                            <div
                                className={`card-content ${
                                    accountRoles.Essential.includes(
                                        account.productType,
                                    )
                                        ? 'primary'
                                        : ''
                                }`}
                            >
                                {!!card && (
                                    <img
                                        src={
                                            !card.cardSerial
                                                ? PlaceholderCard
                                                : cardImages[
                                                      account.productType
                                                  ]
                                        }
                                        alt="suits-me card"
                                    />
                                )}
                                <Card
                                    card={card}
                                    account={account}
                                    position={position}
                                    onAddCardHolderClick={onAddCardHolderClick}
                                ></Card>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CarouselContainer;
